import { getContentfulGqlClient } from "@/contentful/wac-content-gql-client.ts";

import { pricingPageAdditionalContentQuery } from "./gql.ts";

export interface PricingPageAdditionalContentArgs {
    urlSlug: string;
    locale: string;
}

export const getPricingPageAdditionalContent = async ({
    urlSlug,
    locale
}: PricingPageAdditionalContentArgs): Promise<unknown> => {
    const result = await getContentfulGqlClient().query(
        pricingPageAdditionalContentQuery,
        { urlSlug, locale }
    );
    return result.data;
};
